module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/alsobyginakirkham"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Also by Gina Kirkham")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("1999")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Goodbye Cruel World")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("3. ")]), _c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Present Day")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("4. ")]), _c('a', {
    attrs: {
      "href": "#/chapter004"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Lucy In The Sky With Diamonds")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("5. ")]), _c('a', {
    attrs: {
      "href": "#/chapter005"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("A Flash In The Pan…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("6. ")]), _c('a', {
    attrs: {
      "href": "#/chapter006"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Fluffy socks & Furballs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("7. ")]), _c('a', {
    attrs: {
      "href": "#/chapter007"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Nelson’s Delight")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("8. ")]), _c('a', {
    attrs: {
      "href": "#/chapter008"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Frank-ly, My Dear")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("9. ")]), _c('a', {
    attrs: {
      "href": "#/chapter009"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Jerome & Milly Rimple")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("10. ")]), _c('a', {
    attrs: {
      "href": "#/chapter010"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Mariners Maledict")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("11. ")]), _c('a', {
    attrs: {
      "href": "#/chapter011"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Lost property")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("12. ")]), _c('a', {
    attrs: {
      "href": "#/chapter012"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Under The Covers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("13. ")]), _c('a', {
    attrs: {
      "href": "#/chapter013"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Granny Pants & Superman")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("14. ")]), _c('a', {
    attrs: {
      "href": "#/chapter014"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("When Life Gives You……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("15. ")]), _c('a', {
    attrs: {
      "href": "#/chapter015"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Effing & Jeffing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("16. ")]), _c('a', {
    attrs: {
      "href": "#/chapter016"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("A Kipper A Day")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("17. ")]), _c('a', {
    attrs: {
      "href": "#/chapter017"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("What’s It All About Alfie…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("18. ")]), _c('a', {
    attrs: {
      "href": "#/chapter018"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Rod, God & PC Plod")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("19. ")]), _c('a', {
    attrs: {
      "href": "#/chapter019"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Clifford From The Broom Cupboard")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("20. ")]), _c('a', {
    attrs: {
      "href": "#/chapter020"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Fatal Attraction")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("21. ")]), _c('a', {
    attrs: {
      "href": "#/chapter021"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Cracker & A Kodak")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("22. ")]), _c('a', {
    attrs: {
      "href": "#/chapter022"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Rigor-ously Rigid")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("23. ")]), _c('a', {
    attrs: {
      "href": "#/chapter023"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Dame Edna")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("24. ")]), _c('a', {
    attrs: {
      "href": "#/chapter024"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The One")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("25. ")]), _c('a', {
    attrs: {
      "href": "#/chapter025"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("A Pair Of Marilyn Monroe’s")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("26. ")]), _c('a', {
    attrs: {
      "href": "#/chapter026"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Suits you, Sir")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("27. ")]), _c('a', {
    attrs: {
      "href": "#/chapter027"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Frances And The Jam Pot")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("28. ")]), _c('a', {
    attrs: {
      "href": "#/chapter028"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("I’m A Creep, I’m A Weirdo…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("29. ")]), _c('a', {
    attrs: {
      "href": "#/chapter029"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Victorious Secrets")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("30. ")]), _c('a', {
    attrs: {
      "href": "#/chapter030"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Pork Chops, Sausages, Pasties & Pies")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("31. ")]), _c('a', {
    attrs: {
      "href": "#/chapter031"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Air On An Extra Large Thong")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("32. ")]), _c('a', {
    attrs: {
      "href": "#/chapter032"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Hey Big Spender……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("33. ")]), _c('a', {
    attrs: {
      "href": "#/chapter033"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Honeymoon")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("34. ")]), _c('a', {
    attrs: {
      "href": "#/chapter034"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Are you lonesome tonight?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("35. ")]), _c('a', {
    attrs: {
      "href": "#/chapter035"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Meditation, Musings & Mirth")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("36. ")]), _c('a', {
    attrs: {
      "href": "#/chapter036"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Home, Home On The Range…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("37. ")]), _c('a', {
    attrs: {
      "href": "#/chapter037"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Storm In An ‘F’ Cup…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("38. ")]), _c('a', {
    attrs: {
      "href": "#/chapter038"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Potato, Potahto…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("39. ")]), _c('a', {
    attrs: {
      "href": "#/chapter039"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Mother Of The Year")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("40. ")]), _c('a', {
    attrs: {
      "href": "#/chapter040"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("These Boots Were Made For Walking")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("41. ")]), _c('a', {
    attrs: {
      "href": "#/chapter041"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("As Much As Is Needed…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("42. ")]), _c('a', {
    attrs: {
      "href": "#/chapter042"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Silence Is Golden")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("43. ")]), _c('a', {
    attrs: {
      "href": "#/chapter043"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Kilroy Was Here…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("44. ")]), _c('a', {
    attrs: {
      "href": "#/chapter044"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("A Serious Lapse Of Judgement")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("45. ")]), _c('a', {
    attrs: {
      "href": "#/chapter045"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Christmas Sprouts")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("46. ")]), _c('a', {
    attrs: {
      "href": "#/chapter046"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Here’s You Hat, Here’s Your Coat…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("47. ")]), _c('a', {
    attrs: {
      "href": "#/chapter047"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Confession…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("48. ")]), _c('a', {
    attrs: {
      "href": "#/chapter048"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Did I Eat That")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("49. ")]), _c('a', {
    attrs: {
      "href": "#/chapter049"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Naked Truth")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("50. ")]), _c('a', {
    attrs: {
      "href": "#/chapter050"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Pork Pies And Readers’ Wives")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("51. ")]), _c('a', {
    attrs: {
      "href": "#/chapter051"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Bye, Bye, Baby (Baby Goodbye)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("52. ")]), _c('a', {
    attrs: {
      "href": "#/chapter052"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Mr Fix-It")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("53. ")]), _c('a', {
    attrs: {
      "href": "#/chapter053"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("It’s a dog’s life")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("54. ")]), _c('a', {
    attrs: {
      "href": "#/chapter054"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Thongs For The Memory…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("55. ")]), _c('a', {
    attrs: {
      "href": "#/chapter055"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Brazilian, French Or Hollywood")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("56. ")]), _c('a', {
    attrs: {
      "href": "#/chapter056"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Unmasked")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("57. ")]), _c('a', {
    attrs: {
      "href": "#/chapter057"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Wonderful Thing About Tiggers…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("58. ")]), _c('a', {
    attrs: {
      "href": "#/chapter058"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Passing Ships")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("59. ")]), _c('a', {
    attrs: {
      "href": "#/chapter059"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Ashes In The Wind")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("60. ")]), _c('a', {
    attrs: {
      "href": "#/chapter060"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Keeping Mum…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("61. ")]), _c('a', {
    attrs: {
      "href": "#/chapter061"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Heaven Scent")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("62. ")]), _c('a', {
    attrs: {
      "href": "#/chapter062"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Underpanticus Maximus")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("63. ")]), _c('a', {
    attrs: {
      "href": "#/chapter063"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Firkles Make Fugitives")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/anotefromthepublisher"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("A note from the publisher")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/youwillalsoenjoy"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("You will also enjoy:")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/lovebestsellingfiction"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Love best-selling fiction?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheauthor"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("About the Author")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0